// Generated by purs version 0.15.16
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad from "../Control.Monad/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Control_MultiAlternative from "../Control.MultiAlternative/index.js";
import * as Control_Plus from "../Control.Plus/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_TraversableWithIndex from "../Data.TraversableWithIndex/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var monoidEffect = /* #__PURE__ */ Effect.monoidEffect(Data_Monoid.monoidUnit);
var $$void = /* #__PURE__ */ Data_Functor["void"](Effect.functorEffect);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(monoidEffect);
var join = /* #__PURE__ */ Control_Bind.join(Effect.bindEffect);
var voidLeft = /* #__PURE__ */ Data_Functor.voidLeft(Effect.functorEffect);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidUnit);
var forWithIndex = /* #__PURE__ */ Data_TraversableWithIndex.forWithIndex(Effect.applicativeEffect)(Data_TraversableWithIndex.traversableWithIndexArray);
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray);
var applySecond = /* #__PURE__ */ Control_Apply.applySecond(Effect.applyEffect);
var View = /* #__PURE__ */ (function () {
    function View(value0) {
        this.value0 = value0;
    };
    View.create = function (value0) {
        return new View(value0);
    };
    return View;
})();
var Completed = /* #__PURE__ */ (function () {
    function Completed(value0) {
        this.value0 = value0;
    };
    Completed.create = function (value0) {
        return new Completed(value0);
    };
    return Completed;
})();
var Initialising = /* #__PURE__ */ (function () {
    function Initialising() {

    };
    Initialising.value = new Initialising();
    return Initialising;
})();
var Aborted = /* #__PURE__ */ (function () {
    function Aborted() {

    };
    Aborted.value = new Aborted();
    return Aborted;
})();
var Initialised = /* #__PURE__ */ (function () {
    function Initialised() {

    };
    Initialised.value = new Initialised();
    return Initialised;
})();
var Callback = function (x) {
    return x;
};
var Widget = function (x) {
    return x;
};
var shiftMapWidgetWidget = {
    shiftMap: function (f) {
        return f(identity);
    }
};
var newtypeWidget_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCallback_ = {
    Coercible0: function () {
        return undefined;
    }
};
var functorResult = {
    map: function (v) {
        return function (v1) {
            if (v1 instanceof View) {
                return new View(v1.value0);
            };
            if (v1 instanceof Completed) {
                return new Completed(v(v1.value0));
            };
            throw new Error("Failed pattern match at Concur.Core.Types (line 41, column 1 - line 43, column 40): " + [ v.constructor.name, v1.constructor.name ]);
        };
    }
};
var map = /* #__PURE__ */ Data_Functor.map(functorResult);
var unWid = function (v) {
    return v;
};
var runWidget = function (v) {
    return v;
};
var runCallback = function (v) {
    return v;
};
var result = function (f) {
    return function (g) {
        return function (v) {
            if (v instanceof View) {
                return f(v.value0);
            };
            if (v instanceof Completed) {
                return g(v.value0);
            };
            throw new Error("Failed pattern match at Concur.Core.Types (line 37, column 14 - line 39, column 21): " + [ v.constructor.name ]);
        };
    };
};
var mkWidget = function (e) {
    return e;
};
var mkCallback = Callback;
var never = /* #__PURE__ */ mkCallback(/* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Monoid.monoidFn(/* #__PURE__ */ Effect.monoidEffect(monoidEffect))));
var silence = function (w) {
    return mkWidget(function (_cb) {
        return runWidget(w)(function (_res) {
            return $$void(pure(never));
        });
    });
};
var functorCallback = {
    map: function (f) {
        return function (c) {
            return mkCallback(function (cb) {
                return runCallback(c)(function ($104) {
                    return cb(f($104));
                });
            });
        };
    }
};
var map1 = /* #__PURE__ */ Data_Functor.map(functorCallback);
var functorWidget = {
    map: function (f) {
        return function (m) {
            return map1(map(f))(m);
        };
    }
};
var monadWidget = {
    Applicative0: function () {
        return applicativeWidget;
    },
    Bind1: function () {
        return bindWidget;
    }
};
var bindWidget = {
    bind: function (m) {
        return function (f) {
            return mkWidget(function (cb) {
                return function __do() {
                    var cancelerRef = Effect_Ref["new"](mempty)();
                    var runCancelers = join(Effect_Ref.read(cancelerRef));
                    var cancelerA = runWidget(m)(function (res) {
                        if (res instanceof View) {
                            return cb(new View(res.value0));
                        };
                        if (res instanceof Completed) {
                            return function __do() {
                                runCancelers();
                                var cancelerB = runWidget(f(res.value0))(cb)();
                                return Effect_Ref.write(cancelerB)(cancelerRef)();
                            };
                        };
                        throw new Error("Failed pattern match at Concur.Core.Types (line 107, column 7 - line 112, column 42): " + [ res.constructor.name ]);
                    })();
                    Effect_Ref.write(cancelerA)(cancelerRef)();
                    return runCancelers;
                };
            });
        };
    },
    Apply0: function () {
        return $lazy_applyWidget(0);
    }
};
var applicativeWidget = {
    pure: function (a) {
        return mkWidget(function (cb) {
            return voidLeft(cb(new Completed(a)))(pure(mempty1));
        });
    },
    Apply0: function () {
        return $lazy_applyWidget(0);
    }
};
var $lazy_applyWidget = /* #__PURE__ */ $runtime_lazy("applyWidget", "Concur.Core.Types", function () {
    return {
        apply: Control_Monad.ap(monadWidget),
        Functor0: function () {
            return functorWidget;
        }
    };
});
var applyWidget = /* #__PURE__ */ $lazy_applyWidget(88);
var bind1 = /* #__PURE__ */ Control_Bind.bind(bindWidget);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(applicativeWidget);
var monadEffectWidget = function (dictMonoid) {
    return {
        liftEffect: function (eff) {
            return mkWidget(function (cb) {
                return function __do() {
                    var a = eff();
                    cb(new Completed(a))();
                    return mempty;
                };
            });
        },
        Monad0: function () {
            return monadWidget;
        }
    };
};
var monadRecWidget = {
    tailRecM: function (k) {
        return function (a) {
            return bind1(k(a))(function (v) {
                if (v instanceof Control_Monad_Rec_Class.Loop) {
                    return Control_Monad_Rec_Class.tailRecM(monadRecWidget)(k)(v.value0);
                };
                if (v instanceof Control_Monad_Rec_Class.Done) {
                    return pure1(v.value0);
                };
                throw new Error("Failed pattern match at Concur.Core.Types (line 97, column 26 - line 99, column 21): " + [ v.constructor.name ]);
            });
        };
    },
    Monad0: function () {
        return monadWidget;
    }
};
var mapViewResult = function (f) {
    return function (v) {
        if (v instanceof View) {
            return new View(f(v.value0));
        };
        if (v instanceof Completed) {
            return new Completed(v.value0);
        };
        throw new Error("Failed pattern match at Concur.Core.Types (line 46, column 19 - line 48, column 29): " + [ v.constructor.name ]);
    };
};
var mapView = function (f) {
    return function (v) {
        return map1(mapViewResult(f))(v);
    };
};
var initialised = function (v) {
    if (v instanceof Initialising) {
        return Initialised.value;
    };
    return v;
};
var flipEither = function (v) {
    if (v instanceof Data_Either.Left) {
        return new Data_Either.Right(v.value0);
    };
    if (v instanceof Data_Either.Right) {
        return new Data_Either.Left(v.value0);
    };
    throw new Error("Failed pattern match at Concur.Core.Types (line 128, column 1 - line 128, column 51): " + [ v.constructor.name ]);
};
var display = function (v) {
    return mkWidget(function (cb) {
        return function __do() {
            cb(new View(v))();
            return mempty;
        };
    });
};
var semigroupWidget = function (dictMonoid) {
    return {
        append: function (w1) {
            return function (w2) {
                return Control_MultiAlternative.orr(multiAlternativeWidget(dictMonoid))([ w1, w2 ]);
            };
        }
    };
};
var plusWidget = function (dictMonoid) {
    return {
        empty: display(Data_Monoid.mempty(dictMonoid)),
        Alt0: function () {
            return altWidget(dictMonoid);
        }
    };
};
var multiAlternativeWidget = function (dictMonoid) {
    var mempty2 = Data_Monoid.mempty(dictMonoid);
    var fold1 = fold(dictMonoid);
    return {
        orr: function (widgets) {
            return mkWidget(function (cb) {
                return function __do() {
                    var viewsRef = Effect_Ref["new"](Data_Array.replicate(Data_Array.length(widgets))(mempty2))();
                    var cancelerRef = Effect_Ref["new"](mempty)();
                    var renderStateRef = Effect_Ref["new"](Initialising.value)();
                    var runCancelers = join(Effect_Ref.read(cancelerRef));
                    forWithIndex(widgets)(function (i) {
                        return function (w) {
                            return function __do() {
                                var c = runWidget(w)(function (res) {
                                    if (res instanceof View) {
                                        return function __do() {
                                            var views = Effect_Ref.read(viewsRef)();
                                            var v1 = Data_Array.updateAt(i)(res.value0)(views);
                                            if (v1 instanceof Data_Maybe.Nothing) {
                                                return Data_Unit.unit;
                                            };
                                            if (v1 instanceof Data_Maybe.Just) {
                                                Effect_Ref.write(v1.value0)(viewsRef)();
                                                var renderState = Effect_Ref.read(renderStateRef)();
                                                if (renderState instanceof Initialised) {
                                                    return cb(new View(fold1(v1.value0)))();
                                                };
                                                return Data_Unit.unit;
                                            };
                                            throw new Error("Failed pattern match at Concur.Core.Types (line 153, column 11 - line 160, column 31): " + [ v1.constructor.name ]);
                                        };
                                    };
                                    if (res instanceof Completed) {
                                        return function __do() {
                                            Effect_Ref.write(Aborted.value)(renderStateRef)();
                                            runCancelers();
                                            return cb(new Completed(res.value0))();
                                        };
                                    };
                                    throw new Error("Failed pattern match at Concur.Core.Types (line 150, column 32 - line 164, column 27): " + [ res.constructor.name ]);
                                })();
                                return Effect_Ref.modify(function (v) {
                                    return applySecond(v)(c);
                                })(cancelerRef)();
                            };
                        };
                    })();
                    Effect_Ref.modify_(initialised)(renderStateRef)();
                    var views = Effect_Ref.read(viewsRef)();
                    cb(new View(fold1(views)))();
                    return runCancelers;
                };
            });
        },
        Plus0: function () {
            return plusWidget(dictMonoid);
        }
    };
};
var altWidget = function (dictMonoid) {
    return {
        alt: Data_Semigroup.append(semigroupWidget(dictMonoid)),
        Functor0: function () {
            return functorWidget;
        }
    };
};
var alternativeWidget = function (dictMonoid) {
    var plusWidget1 = plusWidget(dictMonoid);
    return {
        Applicative0: function () {
            return applicativeWidget;
        },
        Plus1: function () {
            return plusWidget1;
        }
    };
};
var monoidWidget = function (dictMonoid) {
    var semigroupWidget1 = semigroupWidget(dictMonoid);
    return {
        mempty: Control_Plus.empty(plusWidget(dictMonoid)),
        Semigroup0: function () {
            return semigroupWidget1;
        }
    };
};
export {
    Callback,
    View,
    Completed,
    result,
    mapViewResult,
    mkCallback,
    runCallback,
    never,
    Widget,
    unWid,
    runWidget,
    mkWidget,
    mapView,
    display,
    silence,
    flipEither,
    Initialising,
    Aborted,
    Initialised,
    initialised,
    newtypeCallback_,
    functorResult,
    functorCallback,
    shiftMapWidgetWidget,
    functorWidget,
    newtypeWidget_,
    applyWidget,
    monadWidget,
    applicativeWidget,
    monadRecWidget,
    bindWidget,
    multiAlternativeWidget,
    semigroupWidget,
    monoidWidget,
    altWidget,
    plusWidget,
    alternativeWidget,
    monadEffectWidget
};
//# sourceMappingURL=index.js.map
